// import { datadogRum } from '@datadog/browser-rum';
// import axios from 'axios';
// import { AUTH_ERROR_MSG } from '../../../common/constants';
// import i18n from '../../../i18n/i18n';
// import { redirectUrl } from '../../../common/apiConfig'; // Auth Issue fix

// let isRedirecting = false; // Auth Issue fix
// axios.interceptors.request.use(
//     config =>{
//         const url = config.url;
//         const lastSlashIndex = url.lastIndexOf('/');
//         const acitonPath = url.substring(lastSlashIndex,url.length);
//         if(config.method === 'post'){
//             datadogRum.addAction(`${acitonPath}`, {
//                 requestPayload: config.data,
//                 url: config.url
//             });
//         }else{
//             datadogRum.addAction(`${acitonPath}`, {
//                 url: config.url,
//             });
//         }
//         config.headers['Accept-Language'] = i18n.language;
//         return config;
//     },
//     error =>{
//         datadogRum.addError(error,{
//             // pageStatus:'beta'
//           });
//         // return Promise.reject(error);
//     }
// )
// axios.interceptors.response.use(
//     response =>{
//         return Promise.resolve(response);
//     },
//     // error =>{
//     //     const errorMsg = error && error.response ? error.response.data.message : 'There is an error. Please refresh page or contact administrator.';
//     //     if(error && error.response && error.response.status === 401){
//     //         datadogRum.addError(AUTH_ERROR_MSG ,{
//     //           });
//     //     }else{
//     //         datadogRum.addError(errorMsg,{
//     //             // pageStatus:'beta'
//     //           });
//     //     }
//     //     return Promise.reject(error);
//     // }

//     error => { // Auth Issue fix
//         const status = error && error.response && error.response.status;

//         const errorMsg =
//             (error && error.response && error.response.data && error.response.data.message) ||
//             'There is an error. Please refresh page or contact administrator.';
//         const isAuthError =
//             status === 401 ||
//             errorMsg === AUTH_ERROR_MSG ||
//             (typeof errorMsg === 'string' && errorMsg.includes(AUTH_ERROR_MSG));

//         if (isAuthError) {
//             datadogRum.addError(AUTH_ERROR_MSG, {});

//             if (!isRedirecting) {
//                 isRedirecting = true;
//                 try {
//                     sessionStorage.clear();
//                 } catch (e) {
//                     // ignore
//                 }
//                 window.location.assign(redirectUrl);
//             }

//             return Promise.reject(error);
//         } else {
//             datadogRum.addError(errorMsg, {});
//             return Promise.reject(error); // Auth Issue fix
//         }
//         return Promise.reject(error);
//     }
// )
// export default axios;


import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';
import { AUTH_ERROR_MSG } from '../../../common/constants';
import i18n from '../../../i18n/i18n';
import { redirectUrl } from '../../../common/apiConfig';
import { refreshTokensOnce } from '../../../common/authService';
import { getAuthrization } from '../../home/redux/getAuthrization';
import { store } from '../../../common/store';

let isRedirecting = false;

function forceReLogin() {
  if (isRedirecting) {
    return;
  }

  isRedirecting = true;

  try {
    sessionStorage.clear();
  } catch (error) {
    // Ignore storage failures
  }

  try {
    localStorage.removeItem('persist:root');
  } catch (error) {
    // Ignore storage failures
  }

  window.location.replace(redirectUrl);
}

axios.interceptors.request.use(
  config => {
    const url = config.url || '';
    const lastSlashIndex = url.lastIndexOf('/');
    const actionPath = url.substring(lastSlashIndex, url.length);

    config.headers = config.headers || {};
    config.headers['Accept-Language'] = i18n.language;

    if (config.method === 'post') {
      datadogRum.addAction(actionPath, {
        requestPayload: config.data,
        url: config.url,
      });
    } else {
      datadogRum.addAction(actionPath, {
        url: config.url,
      });
    }

    return config;
  },
  error => {
    datadogRum.addError(error, {});
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error?.response?.status;
    const errorMsg =
      error?.response?.data?.message ||
      'There is an error. Please refresh page or contact administrator.';

    const isAuthError =
      status === 401 ||
      errorMsg === AUTH_ERROR_MSG ||
      (typeof errorMsg === 'string' && errorMsg.includes(AUTH_ERROR_MSG));

    if (!isAuthError) {
      datadogRum.addError(errorMsg, {});
      return Promise.reject(error);
    }

    datadogRum.addError(AUTH_ERROR_MSG, {});

    const originalRequest = error.config;
    const state = store.getState();
    const refreshToken = state?.home?.auth?.refreshToken;

    if (!refreshToken || !originalRequest || originalRequest._retriedAfterRefresh) {
      forceReLogin();
      return Promise.reject(error);
    }

    return refreshTokensOnce(refreshToken)
      .then(tokens => {
        store.dispatch(getAuthrization({
          ...state.home.auth,
          cognitoIdToken: tokens.id_token,
          accessToken: tokens.access_token,
          refreshToken: tokens.refresh_token || refreshToken,
          expiresAt: Date.now() + tokens.expires_in * 1000,
        }));

        originalRequest._retriedAfterRefresh = true;
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${tokens.id_token}`;

        return axios(originalRequest);
      })
      .catch(() => {
        forceReLogin();
        return Promise.reject(error);
      });
  },
);

export default axios;

